import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { List, Stack, Text } from "@mantine/core";

const PC = () => {
  const { t } = useAppTranslation("pages.policies.pc");

  const getSection = (title: string, description: string) => {
    return (
      <>
        <SSHeadline props={{ stack: { align: "left" }, title: { fz: 22 } }}>
          <SSWhiteText>{title}</SSWhiteText>
        </SSHeadline>
        <Text>{description}</Text>
      </>
    );
  };

  const getList = (text: string[]) => {
    return (
      <List withPadding listStyleType="disc">
        {text.map((item, index) => (
          <List.Item key={index}>{getText(item)}</List.Item>
        ))}
      </List>
    );
  };

  const getText = (text: string) => {
    return <Text>{text}</Text>;
  };

  return (
    <Stack className="my-20">
      <SSHeadline props={{ title: { order: 1, fz: 35 } }}>
        <SSWhiteText>{t("title")}</SSWhiteText>
      </SSHeadline>
      <Stack className="mt-10 text-primary-dark-text">
        {getText(t("effectiveDate"))}
        {(t("intro", { returnObjects: true }) as string[]).map((text, i) =>
          getText(text),
        )}
        {getSection(
          t("sections.collection.title"),
          t("sections.collection.text"),
        )}
        {getSection(t("sections.types.title"), "")}
        {getSection(
          t("sections.types.personal.title"),
          t("sections.types.personal.text"),
        )}
        {getList(
          t("sections.types.personal.list", {
            returnObjects: true,
          }) as string[],
        )}
        {getSection(
          t("sections.types.usage.title"),
          t("sections.types.usage.text"),
        )}
        {getSection(
          t("sections.types.tracking.title"),
          t("sections.types.tracking.text"),
        )}
        {(
          t("sections.types.tracking.details", {
            returnObjects: true,
          }) as string[]
        ).map((text, i) => getText(text))}
        {getSection(t("sections.types.tracking.examples.title"), "")}
        {getList(
          t("sections.types.tracking.examples.list", {
            returnObjects: true,
          }) as string[],
        )}
        {getSection(t("sections.use.title"), "")}
        {getText(t("sections.use.intro"))}
        {getList(t("sections.use.list", { returnObjects: true }) as string[])}
        {getSection(t("sections.legal.title"), "")}
        {getText(t("sections.legal.intro"))}
        {getList(t("sections.legal.list", { returnObjects: true }) as string[])}
        {getSection(t("sections.retention.title"), "")}
        {getText(t("sections.retention.text"))}
        {getSection(t("sections.transfer.title"), "")}
        {(
          t("sections.transfer.texts", {
            returnObjects: true,
          }) as string[]
        ).map((text, i) => getText(text))}
        {getSection(t("sections.disclosure.title"), "")}
        {getText(t("sections.disclosure.legal"))}
        {getText(t("sections.disclosure.intro"))}
        {getList(
          t("sections.disclosure.list", { returnObjects: true }) as string[],
        )}
        {getSection(t("sections.security.title"), "")}
        {getText(t("sections.security.text"))}
        {getSection(t("sections.providers.title"), "")}
        {(
          t("sections.providers.texts", {
            returnObjects: true,
          }) as string[]
        ).map((text, i) => getText(text))}
        {getSection(t("sections.analytics.title"), "")}
        {getText(t("sections.analytics.intro"))}
        {getList(
          t("sections.analytics.list", { returnObjects: true }) as string[],
        )}
        {getSection(t("sections.links.title"), "")}
        {(
          t("sections.links.texts", {
            returnObjects: true,
          }) as string[]
        ).map((text, i) => getText(text))}
        {getSection(t("sections.children.title"), "")}
        {getText(t("sections.children.text"))}
        {getSection(t("sections.rights.title"), "")}
        {getText(t("sections.rights.intro"))}
        {getList(
          t("sections.rights.list", { returnObjects: true }) as string[],
        )}
        {getText(t("sections.rights.contact"))}
        {getSection(t("sections.changes.title"), "")}
        {(
          t("sections.changes.texts", {
            returnObjects: true,
          }) as string[]
        ).map((text, i) => getText(text))}
        {getSection(t("sections.contact.title"), "")}
        {getText(t("sections.contact.intro"))}
        {getList(
          t("sections.contact.list", { returnObjects: true }) as string[],
        )}
      </Stack>
    </Stack>
  );
};

export default PC;
